﻿import React, { useState, useEffect } from 'react';
import { HelpDocument } from '../models/help-document';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import HtmlEditor from 'devextreme-react/html-editor';

/*
export interface Props {
    documentId?: number;
    //helpDocument?: HelpDocument;
}

export interface State {
    documentText?: string;
    documentId?: string;
}
*/

export default function Documentation() {
    const [documentText, setDocumentText] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
            getAllData();
    }, []);


    const parts = window.location.href.split('/');
    const documentId = parts[parts.length - 1];

    return (
        <div>
            <HtmlEditor height="725px"
                value={documentText ? documentText : undefined} />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function getDocument() {
        if (documentId) {
            await CrudFunctions.getData(`documentation/helpdocument/${documentId}`)
                .then(data => {
                    setDocumentText(data.html);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Instructions");
                });
        }
    }

    async function getAllData() {
        await getDocument();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
